function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 42.4,
  height: 53,
  rx: 2,
  fill: "#DDEDFC"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.36035,
  y: 10.6,
  width: 25.44,
  height: 4.24,
  rx: 2.12,
  fill: "#449CEE"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6.36035,
  y: 19.08,
  width: 25.44,
  height: 4.24,
  rx: 2.12,
  fill: "#449CEE"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 6.36035,
  y: 27.56,
  width: 12.72,
  height: 4.24,
  rx: 2.12,
  fill: "#449CEE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3348 39.5809H15.6556C15.9534 39.5809 16.1805 39.6037 16.3367 39.6493C16.5467 39.7111 16.7265 39.821 16.8763 39.9789C17.026 40.1367 17.1399 40.3304 17.2181 40.5599C17.2962 40.7878 17.3353 41.0693 17.3353 41.4046C17.3353 41.6992 17.2986 41.9531 17.2254 42.1664C17.1359 42.4268 17.0081 42.6375 16.8421 42.7987C16.7168 42.9207 16.5475 43.016 16.3343 43.0843C16.1748 43.1348 15.9616 43.16 15.6946 43.16H14.3348V39.5809ZM15.0574 40.1864V42.557H15.597C15.7988 42.557 15.9445 42.5456 16.034 42.5228C16.1512 42.4935 16.248 42.4439 16.3245 42.3739C16.4026 42.3039 16.4661 42.1891 16.5149 42.0296C16.5638 41.8685 16.5882 41.6496 16.5882 41.3729C16.5882 41.0962 16.5638 40.8838 16.5149 40.7357C16.4661 40.5876 16.3978 40.472 16.3099 40.389C16.222 40.306 16.1105 40.2498 15.9754 40.2206C15.8745 40.1978 15.6767 40.1864 15.3821 40.1864H15.0574ZM17.804 41.3924C17.804 41.0278 17.8585 40.7219 17.9676 40.4745C18.049 40.2922 18.1596 40.1286 18.2996 39.9837C18.4412 39.8389 18.5958 39.7315 18.7635 39.6615C18.9865 39.5671 19.2436 39.5199 19.535 39.5199C20.0623 39.5199 20.4839 39.6834 20.7996 40.0106C21.117 40.3377 21.2757 40.7927 21.2757 41.3753C21.2757 41.9531 21.1186 42.4056 20.8045 42.7328C20.4904 43.0583 20.0704 43.221 19.5447 43.221C19.0125 43.221 18.5893 43.0591 18.2752 42.7352C17.9611 42.4097 17.804 41.9621 17.804 41.3924ZM18.5486 41.368C18.5486 41.7733 18.6422 42.0809 18.8294 42.2909C19.0166 42.4992 19.2542 42.6034 19.5423 42.6034C19.8304 42.6034 20.0664 42.5 20.2503 42.2933C20.4358 42.085 20.5286 41.7733 20.5286 41.3582C20.5286 40.9481 20.4383 40.6421 20.2576 40.4403C20.0786 40.2385 19.8401 40.1375 19.5423 40.1375C19.2444 40.1375 19.0044 40.2401 18.8221 40.4452C18.6398 40.6486 18.5486 40.9562 18.5486 41.368ZM24.1321 41.8441L24.8328 42.0663C24.7254 42.4569 24.5464 42.7474 24.2957 42.9378C24.0467 43.1266 23.7301 43.221 23.346 43.221C22.8707 43.221 22.4801 43.0591 22.1741 42.7352C21.8681 42.4097 21.7151 41.9653 21.7151 41.4022C21.7151 40.8065 21.8689 40.3442 22.1766 40.0155C22.4842 39.6851 22.8886 39.5199 23.3899 39.5199C23.8278 39.5199 24.1834 39.6493 24.4568 39.9081C24.6196 40.061 24.7417 40.2808 24.823 40.5672L24.1077 40.7381C24.0654 40.5526 23.9767 40.4061 23.8416 40.2987C23.7081 40.1913 23.5454 40.1375 23.3533 40.1375C23.088 40.1375 22.8724 40.2328 22.7063 40.4232C22.542 40.6136 22.4598 40.922 22.4598 41.3485C22.4598 41.801 22.5411 42.1232 22.7039 42.3153C22.8667 42.5073 23.0783 42.6034 23.3387 42.6034C23.5307 42.6034 23.6959 42.5423 23.8343 42.4203C23.9726 42.2982 24.0719 42.1061 24.1321 41.8441ZM25.0916 43.16L26.3147 41.2923L25.2063 39.5809H26.0511L26.7688 40.7308L27.472 39.5809H28.3094L27.1961 41.3192L28.4192 43.16H27.5477L26.7542 41.9222L25.9583 43.16H25.0916Z",
  fill: "#439CEE"
});

function SvgIconFileDocx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDocx);
export default __webpack_public_path__ + "static/media/icon-file-docx.4e937a72.svg";
export { ForwardRef as ReactComponent };